import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import * as userActions from "../../../../_actions/userActions";
import * as matchesActions from "../../../../_actions/matchesActions";
import getMyTopConnectedMembers from "../../../../_selectors/userSelectors/getMyTopConnectedMembers";
import UserWrapper from "./UserWrapper";
import { map } from "lodash";
class FollowList extends Component {
  componentDidMount() {
    const { getTopConnected } = this.props;
    getTopConnected();
  }
  componentWillUnmount() {
    const { clear } = this.props;
    clear();
  }
  render() {
    const { connects } = this.props;
    return (
      <div class="panel panel-default panel-muted">
        <div class="panel-body" style={{ borderBottom: "0px" }}>
          <div class="page-subtitle page-subtitle-centralized margin-bottom-0">
            <h3>Connected Members</h3>
            <p />
          </div>
        </div>

        <div class="panel-body list-contacts" style={{ borderBottom: "0px" }}>
          {map(connects, connect => (
            <UserWrapper user={connect.profileId} key={connect.id} />
          ))}
        </div>
        <div class="panel-body" style={{ borderTop: "0px" }}>
          {connects.length === 0 ? (
            <Link to={`/search`} class="btn btn-primary btn-clean btn-block">
              Start Exploring
            </Link>
          ) : (
            <Link
              to={`/connected-members`}
              class="btn btn-primary btn-clean btn-block"
            >
              View All
            </Link>
          )}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  connects: getMyTopConnectedMembers(state)
});

const mapDispatchToProps = dispatch => ({
  getTopConnected: () => dispatch(userActions.getTopConnectedMembers()),
  clear: () => dispatch(matchesActions.clearMatchedMembers())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FollowList);



// WEBPACK FOOTER //
// ./src/_components/Profile/Home/FollowList/index.js